<template>
    <div class="my-4">
        <h1>Roommate Requests</h1>
        <v-row class="justify-start px-2">
            <v-col
                cols="12"
                md="6"
                lg="4"
                xl="3"
                v-for="request in sentRequests"
                :key="request.id"
            >
                <RoommateCard
                    :requestId="request.request.id"
                    :roommate="request.receiver"
                    :isRequest="true"
                    type="sent"
                />
            </v-col>
            <v-col
                cols="12"
                md="6"
                lg="4"
                xl="3"
                v-for="request in receivedRequests"
                :key="request.id"
            >
                <RoommateCard
                    :requestId="request.request.id"
                    :roommate="request.sender"
                    :isRequest="true"
                    type="received"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import RoommateCard from "../components/RoommateCard";

export default {
    name: "RoommateRemove",
    props: ["sentRequests", "receivedRequests"],
    components: {
        RoommateCard
    }
};
</script>
